// JsFromRoutes CacheKey ea05f54b7f3ff15f98e7e1c6a21b3358
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  authorize: /* #__PURE__ */ definePathHelper('get', '/oauth/authorize'),
  callback: /* #__PURE__ */ definePathHelper('get', '/oauth/callback'),
}
